import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Hidden from "@insite/mobius/Hidden";
import { IconProps } from "@insite/mobius/Icon/Icon";
import MapPin from "@insite/mobius/Icons/MapPin";
import Link, { LinkPresentationProps, StyledIcon } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

export interface LocationsStyles {
    locationWrapper?: InjectableCss;
    locationText?: InjectableCss;
    locationIcon?: IconProps;
    locationInLink?: LinkPresentationProps;
}

export const locationStyles: LocationsStyles = {
    locationWrapper: {
        css: css`
            display: flex;
            gap: 6px;
            padding: 10px 0 10px 0;
        `,
    },
    locationText: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css`
                        display: none;
                    `,
                    css``,
                    css``,
                ]);
            }}
        `,
    },
    locationInLink: {
        icon: {
            iconProps: {
                size: 24,
                css: css`
                    margin-right: 5px;
                `,
            },
        },
        color: "black",
    },
};

type Props = WidgetProps & HasHistory;

export const HeaderLocations = ({ history }: Props) => {
    const styles = locationStyles;
    const viewLocationsClickHandler = () => {
        history.push("/Locations");
    };

    return (
        <StyledWrapper {...styles.locationWrapper} className="locationWrapper">
            <Link
                {...styles.locationInLink}
                onClick={viewLocationsClickHandler}
                icon={{
                    ...styles.locationInLink?.icon,
                    iconProps: { src: MapPin, ...styles.locationInLink?.icon?.iconProps },
                }}
                data-test-selector="locationLink"
            >
                <Typography as="span" {...styles.locationText}>
                    {translate("LOCATIONS")}
                </Typography>
            </Link>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withHistory(HeaderLocations),
    definition: {
        displayName: "Locations",
        icon: "arrow-right-to-bracket",
        group: "Header",
    },
};

export default widgetModule;
